module.exports = __webpack_public_path__ + "static/media/cognitivewalkthroughs.5feccc09.jpeg";